import { render, staticRenderFns } from "./DonutChart311.vue?vue&type=template&id=039cc3fe&scoped=true"
import script from "./DonutChart311.vue?vue&type=script&lang=js"
export * from "./DonutChart311.vue?vue&type=script&lang=js"
import style0 from "./DonutChart311.vue?vue&type=style&index=0&id=039cc3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039cc3fe",
  null
  
)

export default component.exports